export default "__VITE_ASSET__C17tic2D__"